import { useEffect, useState } from "react";
import { Form, Link } from "react-router-dom";

import JobsCardPage from "./JobsCardPage";
import Loader from "../../components/Loader";

import "./MyJobs.css";

import { API_BASE_URL } from "../../config";
import { getAuthToken } from "../../auth/auth";

export default function MyJobsPage() {
  const token = getAuthToken();
  const [jobs, setJobs] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [jobStatus, setJobStatus] = useState("0");

  useState(() => {
    const handleJobs = async () => {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/company/my-jobs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Response("Failed to fetch jobs", {
          status: response.status,
        });
      }

      const result = await response.json();
      setJobs(result.data);
      setIsLoading(false);
    };

    handleJobs();
  }, []);

  const fetchJobs = async (status) => {
    setIsLoading(true);

    const response = await fetch(
      `${API_BASE_URL}/company/my-jobs?status=${status}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Response("Failed to fetch jobs", {
        status: response.status,
      });
    }

    const result = await response.json();
    setJobs(result.data);
    setIsLoading(false);
  };

  const handleChange = (e) => {
    setJobStatus();
    fetchJobs(e.target.value);
  };

  return (
    <>
      <section id="my_jobs">
        <div className="container">
          <div className="my-jobs-page-wrapper">
            <h1>My Jobs</h1>
            <div className="job-status-radio-wrapper">
              <div className="row-essy items-center-essy">
                <div className="col-essy-lg-6 col-essy-md-6">
                  <div
                    className={`jobs-status-wrapper ${
                      isLoading ? "disabled" : ""
                    }`}
                  >
                    <Form>
                      <div className="job-status">
                        <label>
                          <input
                            onChange={handleChange}
                            type="radio"
                            name="job_status"
                            value="0"
                          />
                          <span>Open</span>
                        </label>
                        <label>
                          <input
                            onChange={handleChange}
                            type="radio"
                            name="job_status"
                            value="2"
                          />
                          <span>Closed</span>
                        </label>
                        <label>
                          <input
                            onChange={handleChange}
                            type="radio"
                            name="job_status"
                            value="1"
                          />
                          <span>In Review</span>
                        </label>
                      </div>
                    </Form>
                  </div>
                </div>
                <div className="col-essy-lg-6 col-essy-md-6">
                  <div className="create-new-job-btn-wrapper">
                    <Link className="btn-all-white" to="/create-new-job">
                      Create new job
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {isLoading ? <Loader /> : <JobsCardPage jobs={jobs} />}
          </div>
        </div>
      </section>
    </>
  );
}
